/// <amd-module name="TFS/Admin/Common/Controls/MultiOperationDialog/MultiOperationDialog" />
import * as React from "react";

import { Dialog } from "VSSUI/Dialog";
import { VssComponent } from "VSS/Platform/Layout";
import { ObservableArray, ObservableValue } from "VSS/Core/Observable";
import { ITableColumn, SimpleTableCell, Table, TableColumnStyle, TableRow, TwoLineTableCell } from "VSSUI/Table";
import { IOperationStatus, Result } from "TFS/Admin/Common/Constants/Constants";
import { TitleSize } from "VSSUI/Header";
import { ContentSize } from "VSSUI/Callout";
import { Status, Statuses, StatusSize } from "VSSUI/Status";
import * as Resources from "TFS/Admin/Common/Controls/Resources";
import { IMultiOperationDialogProps } from "TFS/Admin/Common/Controls/MultiOperationDialog/MultiOperationDialog.Props";

export class MultiOperationDialog extends React.Component<IMultiOperationDialogProps> {
    constructor(props: IMultiOperationDialogProps) {
        super(props);
    }

    public render(): JSX.Element {
        return (
            <Dialog
                calloutContentClassName="multioperation-dialog"
                titleProps={{ text: this.props.title, size: TitleSize.Large }}
                onDismiss={this.props.onCancel}
                footerButtonProps={[
                    {
                        disabled: false,
                        text: Resources.CloseButton,
                        onClick: () => this.props.onCancel()
                    }
                ]}
                contentSize={ContentSize.Large}
            >
                <div className={"multioperation"}>
                    <div className={"multioperation-heading"}>{Resources.ActionHeading}</div>
                    <div>{this.props.statusText}</div>
                </div>
                <div className={"multioperation"}>
                    <div className={"multioperation-heading"}>{Resources.StatusHeading}</div>
                    <div className={"multioperation-container"}>
                        <Table
                            itemProvider={new ObservableArray<IOperationStatus>(this.props.operations)}
                            columns={this.getColumns()}
                            className={"permissons-table"}
                        />
                    </div>
                </div>
            </Dialog>
        );
    }

    private getColumns(): ITableColumn<IOperationStatus>[] {
        return [
            {
                id: "Group",
                name: this.props.primaryColumnHeading,
                width: new ObservableValue(-60),
                columnStyle: TableColumnStyle.Secondary,
                renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IOperationStatus>, tableItem: IOperationStatus) =>
                    this._renderCell(columnIndex, tableColumn, tableItem.name)
            },
            {
                id: "Status",
                name: this.props.secondaryColumnHeading,
                width: new ObservableValue(-50),
                columnStyle: TableColumnStyle.Secondary,
                renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IOperationStatus>, tableItem: IOperationStatus) =>
                    typeof tableItem.value === "string"
                        ? this._renderCell(columnIndex, tableColumn, tableItem.value as string)
                        : this._renderStatusCell(columnIndex, tableColumn, tableItem.value)
            },
            {
                id: "Message",
                name: Resources.MultiOperationMessageHeader,
                width: new ObservableValue(-133),
                columnStyle: TableColumnStyle.Secondary,
                renderCell: (rowIndex: number, columnIndex: number, tableColumn: ITableColumn<IOperationStatus>, tableItem: IOperationStatus) =>
                    this._renderCell(columnIndex, tableColumn, tableItem.message)
            }
        ];
    }

    private _renderCell(columnIndex: number, tableColumn: ITableColumn<IOperationStatus>, tableItem: string): JSX.Element {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={columnIndex} contentClassName="display-users-details">
                <span className="multioperation-cell-text">{tableItem}</span>
            </SimpleTableCell>
        );
    }

    private _renderStatusCell(columnIndex: number, tableColumn: ITableColumn<IOperationStatus>, status: Result): JSX.Element {
        return (
            <SimpleTableCell columnIndex={columnIndex} tableColumn={tableColumn} key={columnIndex} contentClassName="display-users-details">
                <span className="multioperation-cell-text">
                    <Status
                        {...(status === Result.Success ? Statuses.Success : status === Result.Partial ? Statuses.Warning : Statuses.Failed)}
                        key={status.toString()}
                        size={StatusSize.m}
                    />
                </span>
            </SimpleTableCell>
        );
    }
}

VssComponent.register("ms.vss-admin-web.multi-operation-dialog", MultiOperationDialog);
